export default __webpack_public_path__ + "media/images/service_skipass-a181d4968312d39a3e4b8804a1a9cc11.jpg";